import httpApiApplication from 'app/http/httpApiApplication';

import { type EconomyActivity } from '../models/economyActivity.model';

export const baseUrl = '/operations';
export const paginateUrl = `${baseUrl}/paginated`;

class EconomyActivityService {
  update(id?: string, env?: EconomyActivity) {
    return httpApiApplication.put(`${baseUrl}/${id}`, env);
  }

  create(env: EconomyActivity) {
    return httpApiApplication.post(baseUrl, env);
  }

  remove(id?: string) {
    return httpApiApplication.delete(`${baseUrl}/${id}`);
  }
}

export default new EconomyActivityService();
